export enum SchedulingFrequency {
    Daily,
    Weekly,
    Monthly,
    CurrentMonth,
    Weekend,
    Overnight
}
